import { c as _c } from "react/compiler-runtime";
export function PaginationDots(t0) {
  const $ = _c(6);
  const {
    total,
    current,
    onChange
  } = t0;
  let t1;
  if ($[0] !== total) {
    t1 = Array.from({
      length: total
    });
    $[0] = total;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== current || $[3] !== onChange || $[4] !== t1) {
    t2 = <div className="flex items-center justify-center gap-2">{t1.map((_, idx) => <button type="button" key={idx} onClick={() => onChange(idx)} className={`rounded-full p-1 transition-colors ${idx === current ? "bg-backgroundBlue" : "bg-none"}`} aria-label={`page ${idx + 1}`}><div className={`h-2.5 w-2.5 rounded-full transition-colors ${idx === current ? "bg-algoprimary" : "bg-borderPrimary"}`} /></button>)}</div>;
    $[2] = current;
    $[3] = onChange;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}